'use strict';

const disassembleISOTimePartToParts = (isoDatePart) => {
  const parts = isoDatePart.split(":").map(Number);
  return {
    hour: parts[0],
    minute: parts[1],
    second: parts[2]
  };
};

module.exports = disassembleISOTimePartToParts;
//# sourceMappingURL=disassembleISOTimePartToParts.cjs.map
